import type { Router } from '@tanstack/react-router';

/*
 * Router ref (spec §4.1). Global 4xx handlers in query-client.ts resolve the
 * current location lazily through this ref, so there is no boot ordering
 * constraint between the router and the query client.
 */
// The concrete router type is only known in router.ts; keep this loose.
type AnyRouter = Router<never, never, never, never, never>;

let router: AnyRouter | undefined;

export function setRouter(r: unknown): void {
  router = r as AnyRouter;
}

export function getRouter(): AnyRouter | undefined {
  return router;
}
